import "../scss/style.scss";
import "./anime.js"
import "./splide.js"
import "./index.js"

// 電話番号の一括管理（ここで変更）
const PHONE_NUMBER = "0336044418";

// 電話番号を動的に設定
document.addEventListener('DOMContentLoaded', function() {
  const telLinks = document.querySelectorAll('.tel-link');
  telLinks.forEach(link => {
    // プレースホルダーを実際の電話番号に置換
    const currentHref = link.getAttribute('href');
    if (currentHref.includes('{{PHONE_NUMBER}}')) {
      link.setAttribute('href', currentHref.replace('{{PHONE_NUMBER}}', PHONE_NUMBER));
    }
  });
});
